import React, { FunctionComponent } from "react";
import { ObjectFieldTemplateProps } from "@rjsf/utils";

/** Reiter Warteliste: Schalter oben, die davon abhängigen Felder gemeinsam in einer grauen Card darunter. */
export const WaitlistSettingsTemplate: FunctionComponent<ObjectFieldTemplateProps> = ({ properties }) => {
  const [main, ...dependent] = properties.filter((property) => !property.hidden);

  return (
    <div>
      {main?.content}
      {dependent.length > 0 && (
        <div className="waitlist-settings__card">
          {dependent.map((property) => (
            <div key={property.name} className="waitlist-settings__item">
              {property.content}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
